import React from 'react';
import Fragment from 'react-dot-fragment';
import styled from 'styled-components';
import { Link } from 'react-router';

import CheckIcon from '../../containers/assets/onboarding-check.png';
import UncheckIcon from '../../containers/assets/onboarding-uncheck.png';

const Wrapper = styled.div`
  flex: 0 0 268px;
  background: #ffffff;
  padding: 40px 30px 40px 40px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #d5d9dd;
  align-self: stretch;
`;

const Line = styled.div`
  width: 1px;
  height: 16px;
  background: #2da548;
  margin-left: 10px;
  margin-bottom: 4px;
`;

const Step = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);
  margin-bottom: 4px;

  img {
    margin-right: 10px;
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const SubStep = styled.p`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.38);
  margin-left: 31px;
  border-left: 1px solid #2DA548;
  padding: 4px 0 4px 15px;

  &:first-of-type {
    margin-top: 12px;
  }
  &:last-of-type {
    margin-bottom: 12px;
  }

  ${p => p.isActive && `
    color: rgba(0, 27, 59, 0.94);

    a:active, a:visited, a:link {
      color: rgba(0, 27, 59, 0.94);
    }
  `}
`;

const generateUrl = (page, currentRound) => {
  const alias = page.alias;
  let step = page.steps[0].alias;
  if (alias === 'trivia') {
    const steps = page.steps.filter(i => !i.hasAnswer);
    step = steps[1].alias;
  }

  return `/onboarding/${alias}${step !== '' ? '/' + step : ''}?round=${currentRound}`;
}

const Navigation = ({ currentPage, pages, history, currentRound }) => (
  <Wrapper>
    {pages.map((page, index) => {
      const isActive = history.filter(i => i.indexOf(page.alias) === 0).length > 0 || currentPage === index;

      return (
        <Fragment key={index}>
          {
            !page.subpage &&
            <Step isActive={isActive}>
              <img src={isActive ? CheckIcon : UncheckIcon} alt="nav icon" />
              {(isActive && currentPage !== index && !page.hasChilds) && (
                <Link to={generateUrl(page, currentRound)}>{page.title}</Link>
              )}
              {(!isActive || currentPage === index || page.hasChilds) && page.title}
            </Step>
          }
          {
            page.subpage &&
            <SubStep isActive={isActive}>
              {(isActive && currentPage !== index) && (
                <Link to={generateUrl(page, currentRound)}>{page.title}</Link>
              )}
              {(!isActive || currentPage === index) && page.title}
            </SubStep>
          }
          {(index < pages.length - 1 && !page.subpage && !pages[index + 1].subpage) && <Line />}
        </Fragment>
      );
    })}
  </Wrapper>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/onboarding/Navigation.js